<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" data-testid="client-banner-phone" @click="open">
            <span v-if="client.phone_number.length > 0" style="border-bottom: 1px dotted gray">
                <i class="fa fa-phone-square" aria-hidden="true"></i>
                <span v-if="client.default_phone_number.length === 9">{{ client.default_phone_number.substring(0, 3) }} {{ client.default_phone_number.substring(3, 6) }} {{ client.default_phone_number.substring(6, 9) }}</span>
                <span v-else-if="client.default_phone_number.length === 13">{{ client.default_phone_number.substring(0, 4) }} {{ client.default_phone_number.substring(4, 7) }} {{ client.default_phone_number.substring(7, 10) }} {{ client.default_phone_number.substring(10, 13) }}</span>
                <span v-else="">{{ client.default_phone_number }}</span>
            </span>
            <span v-else="" style="border-bottom: 1px dotted gray">
                <span class="text-danger"><i class="fa fa-phone-square" aria-hidden="true"></i> Chybí telefonní číslo</span>
            </span>
        </span>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_5_col">
                <div class="row tooltip_header">
                    <div class="col-sm-2 text-left"></div>
                    <div class="col-sm-8">Telefonní čísla klienta</div>
                    <div class="col-sm-2 text-right">
                        <button class="btn btn-sm btn-outline-secondary" @click="close"><i class="fa fa-times" aria-hidden="true"></i></button>
                    </div>
                </div>

                <div class="row" v-if="client.phone_number.length > 0">
                    <table class="table">
                        <thead>
                        <tr class="row m-0">
                            <th class="col-sm-7">telefonní číslo</th>
                            <th class="col-sm-3">výchozí</th>
                            <th class="col-sm-2"> </th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="ea in client.phone_number">
                            <tr class="row m-0 text-left" data-testid="client-phone-row" :class="ea.default ? 'font-weight-bold' : ''">
                                <td class="col-sm-7" v-if="editingId !== ea.id">{{ ea.number }}</td>
                                <td class="col-sm-3" v-if="editingId !== ea.id">{{ ea.default | boolToCS }}</td>
                                <td class="col-sm-10" v-else="">
                                    <form @submit.prevent="submitFormUpdatePhoneNumber">
                                        <div class="input-group">
                                            <input v-model="updatedPhoneNumber.number" type="text" placeholder="telefonní číslo" class="form-control" data-testid="client-phone-edit-input" id="phoneNumber">
                                            <span class="input-group-addon">
                                                      Výchozí:&nbsp;
                                                    <input v-model="updatedPhoneNumber.default" type="checkbox" data-testid="client-phone-edit-default">
                                                  </span>
                                            <input v-model="updatedPhoneNumber.note" type="text" class="form-control" data-testid="client-phone-edit-note" id="phoneNumberNote" placeholder="poznámka">
                                            <button v-if="updatedPhoneNumberPending === false" data-testid="client-phone-edit-save" type="submit" class="btn btn-primary">Uložit</button>
                                            <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                        </div>
                                        <small id="numberError" class="form-text text-danger text-left" v-if="updatedPhoneNumberError.number">{{ updatedPhoneNumberError.number.message }}</small>
                                    </form>
                                </td>
                                <td class="text-right col-sm-2">
                                    <button class="btn btn-sm btn-danger" data-testid="client-phone-delete" @click="deletePhoneNumber(ea.id)" v-if="editingId === false"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                    <button class="btn btn-sm btn-danger disabled" v-else="" disabled="disabled"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                    <button class="btn btn-sm btn-secondary" data-testid="client-phone-edit-cancel" @click="setEditingPhoneNumber(ea)" v-if="editingId === ea.id"><i class="fa fa-times" aria-hidden="true"></i></button>
                                    <button class="btn btn-sm btn-secondary" data-testid="client-phone-edit" @click="setEditingPhoneNumber(ea)" v-else-if="editingId === false"><i class="fa fa-edit" aria-hidden="true"></i></button>
                                    <button class="btn btn-sm btn-secondary disabled" disabled="disabled" v-else=""><i class="fa fa-edit" aria-hidden="true"></i></button>
                                </td>
                            </tr>
                            <tr class="row m-0 " v-if="ea.note !== null && ea.note !=='' && editingId !== ea.id">
                                <td class="col-sm-12 text-left border-top-0 pt-0 font-italic">Poznámka: {{ ea.note }}</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
                <div class="row" v-if="editingId === false">
                    <div class="form-group col-md-12">
                        <form @submit.prevent="submitFormAddPhoneNumber">
                            <div class="input-group">
                                <input v-model="newPhoneNumber.number" type="text" placeholder="telefonní číslo" class="form-control" data-testid="client-phone-input" id="phoneNumber">
                                <span class="input-group-addon">
                          Výchozí:&nbsp;
                        <input v-model="newPhoneNumber.default" type="checkbox" data-testid="client-phone-default">
                      </span>
                                <input v-model="newPhoneNumber.note" type="text" class="form-control" data-testid="client-phone-note" id="phoneNumberNote" placeholder="poznámka">
                                <button v-if="newPhoneNumberPending === false" data-testid="client-phone-add" type="submit" class="btn btn-primary">Přidat</button>
                                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                            </div>
                            <small id="numberError" class="form-text text-danger text-left" v-if="newPhoneNumberError.number">{{ newPhoneNumberError.number.message }}</small>
                        </form>
                    </div>
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        editMode: false,
        isOpen: false,
        newPhoneNumber: {
          default: true
        },
        newPhoneNumberError: false,
        newPhoneNumberPending: false,
        newPhoneNumberDone: false,
        updatedPhoneNumber: {},
        updatedPhoneNumberError: false,
        updatedPhoneNumberPending: false,
        updatedPhoneNumberDone: false,
        deletePhoneNumberError: false,
        deletePhoneNumberPending: false,
        deletePhoneNumberDone: false,
        editingId: false
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      init () {
        this.newPhoneNumber = {default: true}
        this.newPhoneNumberError = false
        this.editingId = false
        this.updatedPhoneNumber = {}
        this.updatedPhoneNumberError = false
        this.updatedPhoneNumberPending = false
        this.updatedPhoneNumberDone = false
        this.deletePhoneNumberError = false
        this.deletePhoneNumberPending = false
        this.deletePhoneNumberDone = false
      },
      open () {
        this.init()
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      },
      edit () {
        this.editMode = true
      },
      view () {
        this.editMode = false
      },
      submitFormAddPhoneNumber () {
        // console.log(this.newPhoneNumber)
        this.newPhoneNumberError = false
        this.postPhoneNumber(this.newPhoneNumber, this.client.id)
      },
      submitFormUpdatePhoneNumber () {
        // console.log(this.updatedPhoneNumber)
        this.updatedPhoneNumberError = false
        this.putPhoneNumber(this.updatedPhoneNumber)
      },
      setEditingPhoneNumber (phoneNumber) {
        if (this.editingId === false) {
          this.updatedPhoneNumber = JSON.parse(JSON.stringify(phoneNumber))
          this.editingId = phoneNumber.id
        } else {
          this.updatedPhoneNumber = {}
          this.editingId = false
        }
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          //
        } else {
          //
        }
      },
      newPhoneNumberDone (val) {
        this.newPhoneNumber = {default: true}
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.newPhoneNumberDone = false
          // this.close()
        }
      },
      deletePhoneNumberDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.deletePhoneNumberDone = false
          // this.close()
        }
      },
      updatedPhoneNumberDone (val) {
        if (val === true) {
          this.editingId = false
          this.updatedPhoneNumber = {}
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.updatedPhoneNumberDone = false
          // this.close()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge_large {
        font-size: xx-large;
    }
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientPhoneNumber.vue?14f6a328